module.exports = __webpack_public_path__ + "img/MIRAEASSET.e9801162.svg";